import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Row, Col, Button } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
import { ChevronDown, UsFlag, ArrowRight, ChevronUp } from '../../../assets/icons';
import { formatePhoneNumber } from '../../../utils/formatPhoneNumber';
import { updateUserProfile } from '../../../services/authApi/userApi';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import { toastNotify } from '../../../utils/toastNotify';
import { notOnlyNumberRegex, zipCodeRegex, cityRegex } from '../../../utils/Validations';
import StateSeeder from '../../../components/StateSeeder/StateSeeder';
import { preventReload } from '../../../utils/preventReload';
import { addUserData } from '../../../store/reducer/accountSlice';

const StepTwo = (props) => {
  const [address, setAddress] = useState();
  const [aptNumber, setAptNumber] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [zipCode, setZipCode] = useState();
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneNumber, setPhoneNumber] = useState(localStorage.getItem('phoneNo') || null);
  const [form] = Form.useForm();
  const [isEdit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userProfileData } = useGetUserProfile();
  const [arrowUp, setArrowUp] = useState(false);
  const dispatch = useDispatch();
  // const autoFilledPhoneno = localStorage.getItem('phoneNo')
  useEffect(() => {
    if (Object.keys(userProfileData).length > 0 && userProfileData.address !== null) {
      const addressDataRes = userProfileData.address;
      form.setFieldsValue({
        address: addressDataRes?.residentialAdd,
        aptNumber: addressDataRes?.apartmentNumber || '',
        city: addressDataRes?.city,
        state: addressDataRes?.state,
        zipcode: addressDataRes?.zipCode,
        countryCode: userProfileData?.countryCode,
        phoneNumber: formatePhoneNumber(userProfileData?.phoneNumber),
      });
      setEdit(true);
    }
  }, [userProfileData]);

  useEffect(() => {
    preventReload(form);
    if (localStorage.getItem('phoneNo')) {
      form.setFieldsValue({ phoneNumber: formatePhoneNumber(phoneNumber) })
    }
  }, [phoneNumber]);

  const handleChangeNumber = (e) => {
    const { value } = e.target;
    const phoneNumber = formatePhoneNumber(value);
    form.setFieldsValue({ phoneNumber: phoneNumber });
    setPhoneNumber(phoneNumber);
  };
  const onStepTwoSubmit = async (values) => {
    setLoading(true);
    const { address, aptNumber, city, phoneNumber, zipcode } = values;
    //convert formate number into normal number (xxxx)-xx-xxx to xxxxxx"
    const phoneNumberInp = `${phoneNumber.slice(1, 4)}${phoneNumber.slice(6, 9)}${phoneNumber.slice(10, 14)}`;
    const stateID = Object.keys(userProfileData).length > 0 && userProfileData?.address?.stateId;
    const addressData = {
      address: {
        residentialAdd: address,
        city: city,
        state: state ? state.toString() : stateID.toString(),
        zipCode: zipcode,
      },
      countryCode: '+1',
      phoneNumber: phoneNumberInp,
    };
    if (aptNumber) addressData['address']['apartmentNumber'] = aptNumber;
    try {
      const resp = await updateUserProfile(addressData);

      if (!resp.isError) {
        !isEdit ? props.nextAction('StepThree') : props.nextAction('StepSix');
        dispatch(addUserData({ userData: resp?.data?.user }));
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Form name='stepTwoForm' form={form} className='auth-form steptwo' onFinish={onStepTwoSubmit} autoComplete='off'>
      <FloatingLabel label='Residential address' inputId='address' isEdit={isEdit} inputValue={address}>
        <Form.Item
          validateTrigger="onBlur"
          name='address'
          rules={[
            {
              required: true,
              message: 'Please enter your address',
            },
            {
              message: 'Please enter valid address',
              pattern: notOnlyNumberRegex,
            },
            {
              min: 2,
              max: 49,
              message: 'Please provide a valid residential address value. Residential address length should be between 2 and 49.',
            },
          ]}
        >
          <Input id='address' value={address} onChange={(e) => setAddress(e.target.value)} />
        </Form.Item>
      </FloatingLabel>
      <FloatingLabel label='C/O, Apt, Suite, Unit' inputId='aptNumber' isEdit={isEdit} inputValue={aptNumber}>
        <Form.Item
          validateTrigger="onBlur"
          name='aptNumber'
          rules={[
            // {
            //   required: true,
            //   message: 'Please enter C/O, Apt, Suite, Unit',
            // },
            {
              min: 1,
              max: 32,
              message: 'Please provide a valid apartment number value. Apartment number length should be between 1 and 32.',
            },
          ]}
        >
          <Input id='aptNumber' value={aptNumber} onChange={(e) => setAptNumber(e.target.value)} />
        </Form.Item>
      </FloatingLabel>

      <Row gutter={16}>
        <Col span={24} xl={12}>
          <FloatingLabel label='City' inputId='city' isEdit={isEdit} inputValue={city}>
            <Form.Item
              validateTrigger="onBlur"
              name='city'
              rules={[
                {
                  required: true,
                  message: 'Please enter valid city',
                  pattern: new RegExp(cityRegex),
                },
                {
                  min: 2,
                  max: 16,
                  message: 'Please provide a valid city value. City length should be between 2 and 16.',
                },
              ]}
            >
              <Input maxLength={'30'} id='city' value={city} onChange={(e) => setCity(e.target.value)} />
            </Form.Item>
          </FloatingLabel>
        </Col>
        <Col span={24} md={12} xl={6}>
          <StateSeeder value={state} setState={(value) => setState(value)} isEdit={isEdit} required={true} />
        </Col>
        <Col span={24} md={12} xl={6}>
          <FloatingLabel label='Zip code' inputId='zipCode' isEdit={isEdit} inputValue={zipCode}>
            <Form.Item
              validateTrigger="onBlur"
              name='zipcode'
              rules={[
                {
                  required: true,
                  message: 'Please enter a valid zip code.',
                  pattern: zipCodeRegex,
                },
              ]}
            >
              <Input
                maxLength={5}
                id='zipCode'
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </FloatingLabel>
        </Col>
        <Col span={24} xl={8}>
          <FloatingLabel label='Country Code' inputId='countryCode' isEdit={isEdit} inputValue={countryCode}>
            <>
              <div id='country-code-anchor' />
              <Form.Item valuePropName='countryCode'>
                <Select
                  id='countryCode'
                  onChange={(value) => setCountryCode(value)}
                  value={countryCode}
                  getPopupContainer={() => document.getElementById('country-code-anchor')}
                  onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
                  suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  defaultValue='+1'
                >
                  <Select.Option value='+1'>
                    <UsFlag marginRight='10px' verticalAlign='middle' top='-2px' />
                    US +1
                  </Select.Option>
                </Select>
              </Form.Item>
            </>
          </FloatingLabel>
        </Col>
        <Col span={24} xl={16}>
          <FloatingLabel label='Phone Number' inputId='phoneNumber' isEdit={isEdit} inputValue={phoneNumber}>
            <Form.Item name='phoneNumber' rules={[{ required: true, message: 'Please enter phone number' }]} validateTrigger="onBlur">
              <Input id='phoneNumber' type='tel' value={phoneNumber} defaultValue={phoneNumber} onChange={(e) => handleChangeNumber(e)} placeholder='(XXX) XXX-XXXX' />
            </Form.Item>
          </FloatingLabel>
        </Col>
      </Row>
      <Form.Item className='auth-form__fixed-submit' shouldUpdate>
        {() => (
          <Button
            type='primary'
            htmlType='submit'
            className='ant-btn-primary--alt'
            loading={loading}
            disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length}
          >
            Continue <ArrowRight marginLeft='10px' verticalAlign='middle' top='-2px' />
          </Button>
        )}
      </Form.Item>
    </Form>
  );
};

StepTwo.propTypes = {
  nextAction: PropTypes.func,
};

export default StepTwo;
